import { currentScale, rasterArt, type RasterArtKeys } from './raster';

/** the 1x file of an emblem is 256 px (the @2x one 512): enough up to 128 CSS px on a 2x screen */
const NATIVE_1X = 256;

/**
 * A Codex emblem (`emblems/<name>`: the daily quest, the shared jackpot) — one edition for both themes, decorative
 * (the block that holds it carries the text). Nothing without the raster: the spot keeps its previous look.
 */
export function Emblem({ name, size, className }: { name: RasterArtKeys['emblems']; size: number; className?: string }) {
  const src = rasterArt('emblems', name, size * currentScale() > NATIVE_1X ? 2 : 1);
  if (!src) return null;
  return (
    <img
      className={className}
      src={src}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      draggable={false}
      data-emblem={name}
      style={{ display: 'block', flex: 'none', objectFit: 'contain' }}
    />
  );
}
